import React from 'react';
import { Img } from 'react-image';

type DevicePreviewBannerProps = {
  imageSrc: string | null;
  title: string;
};

const DevicePreviewBanner: React.FC<DevicePreviewBannerProps> = ({ imageSrc, title }) => {
  return (
    <div className="raffle_image_section__preview_device">
      <div className="raffle_image_section__preview_notch" />
      <div className="raffle_image_section__preview_canvas raffle_image_section__preview_canvas--app">
        <div className="raffle_image_section__app_header">
          <span className="raffle_image_section__form_title_skeleton" />
          <span className="raffle_image_section__form_text_line raffle_image_section__form_text_line--sm" />
        </div>
        <div className="raffle_image_section__app_banner">
          {imageSrc ? (
            <Img src={imageSrc} alt={title} className="raffle_image_section__app_banner_img" />
          ) : (
            <span className="raffle_image_section__app_banner_empty" />
          )}
        </div>
        <div className="raffle_image_section__app_promo">
          <div className="raffle_image_section__app_cards">
            <span className="raffle_image_section__app_card" />
            <span className="raffle_image_section__app_card" />
          </div>
        </div>
        <div className="raffle_image_section__app_dots">
          <span className="raffle_image_section__app_dot raffle_image_section__app_dot--active" />
          <span className="raffle_image_section__app_dot" />
          <span className="raffle_image_section__app_dot" />
        </div>
        <div className="raffle_image_section__app_section">
          <span className="raffle_image_section__form_title_skeleton" />
          <span className="raffle_image_section__form_text_line raffle_image_section__form_text_line--sm" />
          <div className="raffle_image_section__app_cards raffle_image_section__app_cards--small">
            <span className="raffle_image_section__app_card" />
            <span className="raffle_image_section__app_card" />
          </div>
        </div>
        <div className="raffle_image_section__app_nav">
          <span className="raffle_image_section__app_nav_item" />
          <span className="raffle_image_section__app_nav_item" />
          <span className="raffle_image_section__app_nav_item" />
          <span className="raffle_image_section__app_nav_item" />
        </div>
      </div>
      <div className="raffle_image_section__preview_safe" />
    </div>
  );
};

export default DevicePreviewBanner;
